export default __webpack_public_path__ + "static/media/foto.96dc3f9b.jpg";